(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["dropdown~index~input~input-number~loading~modal~table~tag~timeline~tree~treeSelect"],{

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var directives__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);

var base = {};

var install = function install(Vue) {
  base.Vue = Vue;
  Vue.use(directives__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

base.install = install;
/* harmony default export */ __webpack_exports__["a"] = (base);

/***/ })

}]);